import React, { type FC, useState } from "react";
import SigninForm from "@components/AuthFlow/Signin/SigninForm";
import { withPrefix } from "@tracking/tracking";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import NewsletterOption from "../NewsletterOption";
import { ButtonText } from "../Passwordless/ButtonText";
import SocialAuth from "../SocialAuth";
import { type SigninBodyProps } from "./contract";
import { PASSWORDLESS_ID } from "./datameshIds";

const { SIGNIN } = screenNames;

const SigninBody: FC<SigninBodyProps> = ({
  email,
  setEmail,
  onPasswordlessClick,
  onForgotPasswordClick,
  closeScreen,
}) => {
  const { t } = useTranslation();
  const { state } = useScreenState();

  const [acceptsNewsletter] = useState(state.userData.acceptsNewsletter);

  return (
    <>
      <SigninForm
        email={email}
        setEmail={setEmail}
        closeScreen={closeScreen}
        onForgotPasswordClick={onForgotPasswordClick}
      />
      <ButtonText
        trackingId={withPrefix(PASSWORDLESS_ID, state.trackingPrefix)}
        onClick={onPasswordlessClick}
      >
        {t("authentication.signin.passwordless")}
      </ButtonText>
      <SocialAuth
        google={{
          screen: SIGNIN,
          closeScreen: closeScreen,
          trackingPrefix: state.trackingPrefix,
        }}
      />

      <NewsletterOption shouldShow={!acceptsNewsletter} />
    </>
  );
};

export default SigninBody;
